import React,{Component} from 'react';
import info from './img/info.png';
import croix from './img/croix.png';
import parse from 'html-react-parser';

class InfoBulle extends Component {
	state ={
		display:false,
	}
	displayContent = ()=>{
		this.setState (({display})=>{
			return {display:!display};
		});
	}

	infoBtnStyle= {
    	background: `url(${info})top left no-repeat`,
    	cursor: 'pointer',
    	paddingBottom: '2px',
    	backgroundSize:'20px',
    	backgroundPosition:'center',
    	marginLeft : '-2px',
    	marginTop:'-4px',
    	height:'32px',
    	display:'inline-block',
    	position:'relative'
	}
	imageStyle = {
		height:'auto',
		display:'inline',
		position : 'initial'
	}
	spanStyle = {
		display:'inline',
		fontSize:'1em'
	}



	render(){
		return <>
			
			<span onClick={this.displayContent} className="info" style={this.infoBtnStyle}></span>
			{
				(this.state.display) ? 
					<div className="info-bulle"  >
					  <div>
					    <div>
					      <img src={info} alt="Info" className="info-img" style={this.imageStyle}/>
					      <span style={this.spanStyle} >Infos</span>
					    </div>
					    <div>
					      <img  src={croix}alt="Croix info" onClick={this.displayContent} style={this.imageStyle} />
					    </div>
					  </div>
					  <div className="noteContent"> { parse (this.props.message) } </div>
					  
					</div>
					: ""
			}
		</>

	}
}
export default InfoBulle;